'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BoxCTA, Chip, LegacyLink, Text } from '@lichtblick/ui-components';
import { getHref } from '../../helpers';
import { RichText } from '../../helpers/RichText';
import { getColor } from '../../utils';
import { AButton } from '../AButton';
import { AImage } from '../AImage/AImage';
import { MDataList } from '../MDataList';
import { Badge, Body, Card, Container, Footer, FooterText, Header, StyledAccentText, StyledHeadline, StyledLinkText, StyledTagline, StyledText, TariffIcon } from './MTariffCard.styles';
const elementMappers = {
    p: ({ children })=>/*#__PURE__*/ _jsx(Text, {
            size: "Xs",
            children: children
        }),
    a: ({ children, href })=>/*#__PURE__*/ _jsx(StyledLinkText, {
            size: "xs",
            children: /*#__PURE__*/ _jsx(LegacyLink, {
                href: href ?? '#',
                children: children
            })
        })
};
export const MTariffCard = ({ badge, button, chip, chipColor, footerText, footerTextColor, headline, icon, infoDialogButton, onClick, price, priceColor, primaryList, secondaryLists, subheadline, tagline, theme })=>{
    return /*#__PURE__*/ _jsxs(Card, {
        $themeColor: getColor(theme) ?? undefined,
        "data-tariff-name": headline,
        "data-testid": "tariff-card",
        children: [
            badge && /*#__PURE__*/ _jsx(Badge, {
                children: /*#__PURE__*/ _jsx(Text, {
                    size: "S",
                    children: badge
                })
            }),
            /*#__PURE__*/ _jsxs(Header, {
                children: [
                    /*#__PURE__*/ _jsx(StyledTagline, {
                        size: "xs",
                        children: tagline ?? ''
                    }),
                    /*#__PURE__*/ _jsx(StyledHeadline, {
                        renderAs: "h3",
                        size: "S",
                        children: headline ?? ''
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Body, {
                children: [
                    /*#__PURE__*/ _jsx(TariffIcon, {
                        children: icon?.length === 1 && /*#__PURE__*/ _jsx(AImage, {
                            ...icon[0]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Container, {
                        children: [
                            /*#__PURE__*/ _jsx(StyledText, {
                                bold: true,
                                size: "xs",
                                children: subheadline ?? ''
                            }),
                            /*#__PURE__*/ _jsx(StyledAccentText, {
                                $color: (priceColor ? getColor(priceColor) : undefined) ?? 'black',
                                size: "L",
                                children: price ?? ''
                            }),
                            infoDialogButton?.[0] && /*#__PURE__*/ _jsx(AButton, {
                                ...infoDialogButton[0],
                                isSlim: true,
                                variant: "link"
                            }),
                            chip && /*#__PURE__*/ _jsx(Chip, {
                                backgroundColor: (chipColor ? getColor(chipColor) : undefined) ?? getColor(theme),
                                label: chip
                            })
                        ]
                    }),
                    primaryList?.[0]?.items && /*#__PURE__*/ _jsx(MDataList, {
                        hasTopLine: true,
                        icon: "CheckIconXs",
                        isBold: true,
                        items: primaryList[0].items,
                        topLineColor: theme
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Footer, {
                children: [
                    secondaryLists && secondaryLists.length > 0 && secondaryLists.map((item)=>/*#__PURE__*/ _jsx(MDataList, {
                            hasDottedLine: true,
                            icon: "CheckIconXs",
                            iconColor: 'light-moss',
                            items: item?.items ?? []
                        }, `m-tariff-card-m-data-list-${item._uid}`)),
                    footerText && /*#__PURE__*/ _jsx(FooterText, {
                        $color: footerTextColor ? getColor(footerTextColor) : undefined,
                        children: /*#__PURE__*/ _jsx(RichText, {
                            elementMappers: elementMappers,
                            richText: footerText
                        })
                    }),
                    button?.[0] && /*#__PURE__*/ _jsx(BoxCTA, {
                        as: "a",
                        href: getHref(button[0]),
                        onClick: onClick,
                        children: button[0].text
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=MTariffCard.js.map